import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { useTranslation } from "react-i18next";

function VisaPrepUniEnrolmentStep1(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_RECEIVED_CAS}
        label={t('forms.visa:haveYouReceivedYourCasYet')}
        value={boolToYesNo(props.hasReceivedCas)}
      />
      {props.hasReceivedCas ? (
        <SummaryRow
          className={'visa-summary'}
          key={`${VQ.STUDIES_CONFIRMATION_NUMBER}`}
          value={props.studiesConfirmationNumber}
          label={t('forms.visa:whatIsYourConfirmationOfAcceptan')}
        />
      ) : null}
      <SummaryRow
        className={'visa-summary'}
        key={VQ.COURSE_END_DATE}
        label={t('forms.visa:courseEndDate')}
        value={props.courseEndDate}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.ALREADY_STARTED_STUDYING}
        label={t('forms.visa:haveYouAlreadyStartedStudyingThi')}
        value={boolToYesNo(props.alreadyStartedStudying)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.ASSESSED_BY_SPONSOR}
        label={t('forms.visa:assessedBySponsor')}
        fullLabel={
          'Have you been assessed by the sponsor by other means, for example references or a portfolio of artwork?'
        }
        value={boolToYesNo(props.assessedBySponsor)}
      />
    </>
  );
}

export default VisaPrepUniEnrolmentStep1;
